import { render, staticRenderFns } from "./sidebarWeb.vue?vue&type=template&id=3dcbf7b8&scoped=true"
import script from "./sidebarWeb.vue?vue&type=script&lang=js"
export * from "./sidebarWeb.vue?vue&type=script&lang=js"
import style0 from "./sidebarWeb.vue?vue&type=style&index=0&id=3dcbf7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcbf7b8",
  null
  
)

export default component.exports